import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.353 23.004h17.283q.955 0 1.651-.415a2.8 2.8 0 0 0 1.067-1.123q.382-.697.382-1.561a2.8 2.8 0 0 0-.113-.775 3 3 0 0 0-.303-.753L14.662 3.295a2.94 2.94 0 0 0-1.157-1.168 3.02 3.02 0 0 0-3.021 0q-.72.393-1.157 1.168L.668 18.389a3 3 0 0 0-.415 1.516q0 .865.37 1.56.382.709 1.079 1.124.696.415 1.65.415Zm.01-1.763q-.583 0-.943-.415a1.37 1.37 0 0 1-.348-.921 1.7 1.7 0 0 1 .146-.674l8.648-15.083a1.15 1.15 0 0 1 .494-.471q.303-.157.64-.157.325 0 .618.157.303.146.494.471l8.636 15.094a1.325 1.325 0 0 1-.19 1.584q-.36.415-.944.415H3.364ZM12 15.424q.842 0 .854-.887l.168-5.93a.89.89 0 0 0-.292-.708 1 1 0 0 0-.741-.292q-.46 0-.753.281a.92.92 0 0 0-.27.708l.147 5.94q.022.888.887.888m0 3.65q.483 0 .842-.337a1.08 1.08 0 0 0 .37-.831q0-.495-.358-.831a1.2 1.2 0 0 0-.854-.337q-.495 0-.854.348a1.08 1.08 0 0 0-.359.82q0 .483.36.83.36.338.853.338"
    }, null, -1)
  ])))
}
export default { render: render }